import { VariableType } from 'json-to-graphql-query';
import { Resource } from './resource';
/**
 *  Resource usług klienta
 *
 * @export
 * @class ClientBenefitResource
 * @extends {Resource}
 */
export class ClientBenefitResource extends Resource {
    async benefitsByProfileId(filters) {
        const query = this.prepareOptions({
            query: {
                __variables: { filters: 'BenefitUseFilters!' },
                benefitUsages: {
                    count: true,
                    __args: {
                        filters: new VariableType('filters')
                    },
                    list: {
                        id: true,
                        created: true,
                        modified: true,
                        price: true,
                        value: true,
                        benefit: {
                            name: true,
                            type: true,
                            state: true,
                            partner: {
                                name: true
                            }
                        }
                    }
                }
            }
        });
        const data = await this.query({
            query,
            variables: { filters }
        }, 'benefitUsages');
        return Promise.resolve(data);
    }
}
export const clientBenefitResource = new ClientBenefitResource();
//# sourceMappingURL=clientBenefit.resource.js.map